import { LandingPage } from 'pages/LandingPage';
import { LandingRedirect } from 'pages/LandingRedirect';
import { MapBlockedPage } from 'pages/MapBlockedPage';
import { CreateMinutePage } from 'pages/minute/CreateMinutePage';
import { MinutePage } from 'pages/minute/MinutePage';
import { TermsPage } from 'pages/minute/TermsPage';
import { Route } from 'react-router-dom';

export default [
    <Route path="/map-blocked" element={<MapBlockedPage />} key="200" />,
    <Route path="/create" element={<CreateMinutePage />} key="201" />,
    <Route path="/minute/:id" element={<MinutePage />} key="202" />,
    <Route path="/terms" element={<TermsPage />} key="203" />,
    <Route path="/" element={<LandingRedirect />} key="204" />,
    <Route path="/old" element={<LandingPage />} key="205" />
];
